module.exports = __webpack_public_path__ + "img/cpjs3.f66df521.png";